class AvtHeaderGarage extends HTMLElement {
  connectedCallback() {
    if (this.connected) return;
    this.connected = true;
    this.count = this.querySelector('[data-avt-header-garage-count]');
    document.addEventListener('avt:garage-change', this.handleGarageChange);
    window.addEventListener('storage', this.handleStorage);
    window.addEventListener('pageshow', this.handlePageShow);
    this.render();
  }

  disconnectedCallback() {
    this.connected = false;
    document.removeEventListener('avt:garage-change', this.handleGarageChange);
    window.removeEventListener('storage', this.handleStorage);
    window.removeEventListener('pageshow', this.handlePageShow);
  }

  garage() {
    if (typeof window.AVTGarage?.read === 'function') {
      return window.AVTGarage.read();
    }
    try {
      return JSON.parse(window.localStorage.getItem('avt-garage-v1')) || {};
    } catch {
      return {};
    }
  }

  render(garage = this.garage()) {
    const bikes = Array.isArray(garage?.bikes) ? garage.bikes : [];
    const count = bikes.length;
    if (!count) {
      this.hidden = true;
      return;
    }
    const countLabel = count === 1
      ? this.dataset.bikeLabel
      : this.dataset.bikesLabel;
    if (this.count) this.count.textContent = String(count);
    const link = this.querySelector('a');
    link?.setAttribute('aria-label', `${this.dataset.label}: ${count} ${countLabel}`);
    this.hidden = false;
  }

  handleGarageChange = (event) => {
    this.render(event.detail?.garage);
  };

  handleStorage = (event) => {
    if (
      event.key === 'avt-garage-v1'
      || event.key === 'avt-fitment-selection'
    ) {
      this.render();
    }
  };

  handlePageShow = () => {
    this.render();
  };
}

if (!customElements.get('avt-header-garage')) {
  customElements.define('avt-header-garage', AvtHeaderGarage);
}
